import { configureStore } from '@reduxjs/toolkit';
import loadingSlice from './loadingSlice.tsx';
import  counterReducer from './GetTimeSlice.tsx'
import { clientReducer} from './clientSlice.tsx';
import { businessReducer } from './businessSlice.tsx';
import MonthSlice from './MonthSlice.tsx';

const store = configureStore({
  reducer: {
    loader: loadingSlice,
    counter: counterReducer,
    client: clientReducer,
    busines: businessReducer,
    month: MonthSlice
    },
    // middleware: (getDefaultMiddleware) => getDefaultMiddleware({ thunk: true })
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;

